import React, { Component } from 'react'
import { Button, Form, Table, Modal, Input, message, Icon, Switch, InputNumber } from 'antd'

import { getReturnCause, saveReturnCause, reviseReturnCause } from '_src/api/api'

@Form.create({ name: '' })
class ReturnReason extends Component {
  constructor (props) {
    super(props)
    this.id = ''
    this.param = {
      status: '',
      pageNum: 0,
      totalElements: 0
    }
    this.status = ''
    this.pageNum = 0
    this.totalElements = 0
    this.state = {
      loading: true,
      visible: false,
      dataList: [],
    }
  }

  componentDidMount () {
    this.loadData()
  }
  loadData () {
    this.setState(()=>({
      loading: true
    }))
    const { status, pageNum }= this.param
    getReturnCause({status: status, pageSize: 10, pageNum: pageNum})
      .then(res=>{
        const { data } = res
        const { content, totalElements } = data
        this.param.totalElements = totalElements
        const dataList = content.map(item=>{
          return {...item, key: item.id}
        })
        this.setState({
          dataList: dataList,
          visible: false,
          loading: false
        })
      })
  }
  columns = () => {
    return [
      {
        title: <span>原因类型</span>,
        align: 'center',
        dataIndex: 'causeType',
        key: 'causeType',
      },
      {
        title: <span>排序</span>,
        align: 'center',
        dataIndex: 'sortOrder',
      },

      {
        title: <span>是否启用</span>,
        align: 'center',
        dataIndex: 'status',
        render: item => <div>{item === 1 ? <Icon type="check-circle" theme="twoTone" style={{color: 'green', fontSize: 20}} /> : '/' }</div>
      },
      {
        title: <span>添加时间</span>,
        align: 'center',
        dataIndex: 'createAt',
        // render: item => <div>{item ? <Icon type="check-circle" theme="twoTone" style={{color: 'green', fontSize: 20}} /> : '/' }</div>
      },
      {
        title: <span>操作</span>,
        align: 'center',
        dataIndex: 'opt',
        render: (_, record) => <div>
          <Button icon="form" type='primary' onClick={()=>{ this.onEdit(record) }} style = {{marginRight: 10}}>编辑</Button>
        </div>,
      },
    ]
  }


  handleCancel = () => this.setState({ previewVisible: false });
  onEdit (record) {
    this.setState(()=>({
      erroMsg: '',
    }))
    const { id } = record || ''
  
    this.id = id || ''
    this.upLoadFlage = !toString(this.id) // 重置更新状态
    this.setState({
      visible: true,
      
    }, ()=>{
      const { status, causeType, sortOrder } = record || {}
      // 设置对话框信息
      this.props.form.setFieldsValue({
        status: !!status,
        causeType,
  
        sortOrder,
      })
    })
  }

  onSubmit = (e) => {
    e.preventDefault()
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.hide = message.loading(this.id?'退货原因修改中':'退货原因添加中', 0)
        // 需要更新图片
        let param = values
        let { status } = param
        status = status? 1 : 0
        param = {...param, status}
        this.handleReturnCause({...param})  
        
          
        this.setState({
          erroMsg: ''
        })
      }
    })
  }

  // 保存专题
  handleReturnCause (param) {
    if (!this.id) {
      // 添加
      saveReturnCause(param)
        .then(()=>{
          this.hide && this.hide()
          this.loadData()
          message.success('添加成功', 1.5)
        })
        .catch(()=>{
          this.hide()
          // this.loadData()
          message.success('添加失败', 1.5)
        })
    }
    else {
      // 修改
      reviseReturnCause(this.id, param)
        .then(()=>{
          this.hide && this.hide()
          this.loadData()
          message.success('修改成功', 1.5)
        })
        .catch(()=>{
          this.hide()
          message.success('修改失败', 1.5, ()=>{
            this.loadData()
          })
        })
    }
  }

  handleEditCancel = () => {
    this.setState({ visible: false })
  }
  // handleSearch = (e) => {
  //   this.param.status = e.target.value
  //   this.param.pageNum = 0
  //   this.loadData()
  // }
  pangeChange = (page) => {
    this.param.pageNum = (page - 1)
    this.loadData()
  }
  render () {
    const { dataList, visible, loading } = this.state
    const { getFieldDecorator } = this.props.form

    return (
      <div className = "page_content">
        <div className = "simple_top">
          <Button type = "primary" icon="plus" onClick = { () => { this.onEdit() } }>添加</Button>
          {/* <Radio.Group defaultValue="" buttonStyle="solid" className = 'searchSelect'
            onChange = { this.handleSearch }
          >
            <Radio.Button value="">全部</Radio.Button>
            <Radio.Button value={1}>显示状态</Radio.Button>
            <Radio.Button value={0}>禁用状态</Radio.Button>
          </Radio.Group> */}
        </div>
        <Table
          loading = {loading} 
          bordered
          columns = {this.columns()} 
          dataSource = {dataList}
          pagination = {{ 
            current: (this.param.pageNum + 1),
            total: this.param.totalElements,
            onChange: (page) => { this.pangeChange(page) }
          }}
        />
        <Modal
          title={ '退货原因类型设置'}
          width={600}
          visible={visible}
          onCancel={this.handleEditCancel}
          footer={false}
          destroyOnClose // 关闭时候销毁
        >
          <Form onSubmit={this.onSubmit} className="advert-form" labelCol = {{span: 4}} wrapperCol = {{span: 18}}>
            <Form.Item label="是否显示">
              {getFieldDecorator('status', { valuePropName: 'checked' })(
                <Switch />
              )}
            </Form.Item>

            <Form.Item label="原因类型" number>
              {getFieldDecorator('causeType', { rules: [{ required: true, message: '原因类型不能为空', }] })(
                <Input placeholder="请输入原因类型" />)}
            </Form.Item>
            <Form.Item label="位置排序" number>
              {getFieldDecorator('sortOrder', { rules: [{ required: true, message: '位置排序不能为空', }] })(
                <InputNumber placeholder="数字越大越靠前" style={{ width: 150}} />)}
            </Form.Item>
            <Form.Item style={{ paddingLeft: 80 }}>
              <Button type="primary" htmlType="submit" icon='save' style={{ width: 390, float: 'left'}}>保存</Button>
            </Form.Item>
          </Form>
        </Modal>
      </div>
    )
  }
}

export default ReturnReason